// src/pages/HomePage.jsx
import React from "react";
import Leaderboard from "../components/Leaderboard";
import HeroSlider from "./HeroSlider";
import ColorScale from "./ColorScale";
import MyChart from "../components/MyChart";
import Methalogy from "./Methalogy";
import OverallResult from "./OverallResult";
import MySecondChart from "../components/MySecondChart";
import MethodologyPage from "./MethodologyPage";
// import ColorTracker from "../components/colortracker";

const HomePage = () => {
  return (
    <>
    <HeroSlider/>
    <div className="container">
      <header style={{ padding: 20 }}>
        {/* <h1>Disclosure Leaderboard</h1> */}
      </header>
      {/* <ColorTracker/> */}
       {/* <ColorScale/> */}
      {/* <Leaderboard /> */}
      <MethodologyPage/>
      <Methalogy/>
      {/* <OverallResult/> */}
      {/* <MySecondChart/> */}
     
    </div>
    </>
  );
};

export default HomePage;
